var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'react-final-form';
import { FieldErrorText } from '@/components/functional/Form/FieldErrorText';
import { TextFieldBase } from '@/components/functional/Form/TextField/TextFieldBase';
import { parseEmpty } from '@/utils/form/parse';
export const TextField = (props) => {
    const { isHideValidateError = false, name, parseEmptyValue = undefined } = props, otherProps = __rest(props, ["isHideValidateError", "name", "parseEmptyValue"]);
    return (_jsxs(_Fragment, { children: [_jsx(Field, Object.assign({}, otherProps, { component: TextFieldBase, name: name, parse: parseEmpty(parseEmptyValue) })), !isHideValidateError && _jsx(FieldErrorText, { name: name })] }));
};
